import Vue from 'vue';

import * as VueGoogleMaps from 'vue2-google-maps'

import GoogleMap from './components/GoogleMap';

Vue.use(VueGoogleMaps, {
    load: {
        key: 'AIzaSyBpr-VICZv-Mq9Frd2r5xdeAS65T9GIfvU',
    }
});

const googleMap = new Vue({
    el: '#google-map',
    components: {
        GoogleMap
    }
})